/**
 * 清除 URL 中指定的 query 参数（默认清 code）
 * 兼容 hash / history 路由
 * 不刷新页面
 *
 * @param {string|string[]} keys 要清除的参数名
 */
export function clearUrlQuery(keys = "code") {
    const keyList = Array.isArray(keys) ? keys : [keys];

    let url = window.location.href;

    keyList.forEach((key) => {
        const reg = new RegExp(`([?&])${key}=[^&#]*(&)?`, "g");
        url = url.replace(reg, (match, p1, p2) => {
            return p2 ? p1 : "";
        });
    });

    // 清理多余 ? 或 &
    url = url.replace(/[?&]$/, "");

    if (url !== window.location.href) {
        window.history.replaceState(null, "", url);
    }
}
